export default "__VITE_ASSET__BWiZhZX1__"